import { DEFAULT_SETTINGS } from '@/types/settings';

const LEADERBOARD_KEY = 'packman_leaderboard';
const SETTINGS_KEY = 'packman_settings';

export function isStorageAvailable(): boolean {
  try {
    const testKey = '__packman_storage_test__';
    localStorage.setItem(testKey, 'test');
    const result = localStorage.getItem(testKey);
    localStorage.removeItem(testKey);
    return result === 'test';
  } catch {
    return false;
  }
}

export function initializeStorage(): void {
  if (!isStorageAvailable()) {
    console.warn('PackMan: LocalStorage is not available. Scores and settings will not persist.');
    return;
  }

  initializeLeaderboard();
  initializeSettings();

  console.log('PackMan: Storage initialized successfully.');
}

function initializeLeaderboard(): void {
  const existing = localStorage.getItem(LEADERBOARD_KEY);
  if (existing === null) {
    localStorage.setItem(LEADERBOARD_KEY, JSON.stringify([]));
    return;
  }

  try {
    const parsed: unknown = JSON.parse(existing);
    if (!Array.isArray(parsed)) {
      localStorage.setItem(LEADERBOARD_KEY, JSON.stringify([]));
    }
  } catch {
    localStorage.setItem(LEADERBOARD_KEY, JSON.stringify([]));
  }
}

function initializeSettings(): void {
  const existing = localStorage.getItem(SETTINGS_KEY);
  if (existing === null) {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(DEFAULT_SETTINGS));
    return;
  }

  try {
    const parsed: unknown = JSON.parse(existing);
    if (typeof parsed !== 'object' || parsed === null) {
      localStorage.setItem(SETTINGS_KEY, JSON.stringify(DEFAULT_SETTINGS));
      return;
    }
    const obj = parsed as Record<string, unknown>;
    if (typeof obj['volume'] !== 'number') {
      localStorage.setItem(SETTINGS_KEY, JSON.stringify(DEFAULT_SETTINGS));
    }
  } catch {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(DEFAULT_SETTINGS));
  }
}
